<template>
  <div v-if="store.lobbyZoom" class="zoom-datas">
    <LobbyZoomCard :key="store.lobbyZoom._id" :lobby="store.lobbyZoom" />
    <RouterView />
  </div>
  <NoData v-else />
</template>

<script setup>
import LobbyZoomCard from "../molecules/LobbyZoomCard.vue";
import NoData from "@follaw-fr/components/reusable/atoms/NoData.vue";

import { useLobbiesStore } from "@follaw-fr/stores/lobbies";

const store = useLobbiesStore();
</script>

<style lang="scss" scoped>
.zoom-datas {
  display: grid;
  grid-template-columns: 1fr 2fr;
  gap: 10px;

  @container (max-width: 1100px) {
    grid-template-columns: 1fr;
  }
}
</style>
